import axios from 'axios';
import router from '../router'; // For auth redirects

// Helper to get base URL and Auth Token
const getApiConfig = () => {
  const userToken = localStorage.getItem('userToken');
  if (!userToken) {
    // router.push({ name: 'login' }); // Commented out for dev, uncomment for prod
    console.error('No user token, redirecting to login.');
    throw new Error('No user token, redirecting to login.');
  }
  const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
  return {
    baseURL,
    headers: { Authorization: `Bearer ${userToken}` }
  };
};

const state = {
  purchases: [],
  selectedOrder: null,
};

const mutations = {
  SET_PURCHASES(state, purchases) {
    state.purchases = purchases;
  },
  SET_SELECTED_ORDER(state, selectedOrder) {
    state.selectedOrder = selectedOrder;
  },
};

const actions = {
  /**
   * Fetches production orders based on filters or search query
   */
  async fetchPurchases({ commit }, { fin, check, search }) {
    try {
      const { baseURL, headers } = getApiConfig();
      const params = {};

      if (search && search.trim() !== '') {
        params.search = search;
      } else {
        params.fin = fin;
        params.check = check;
      }

      const response = await axios.get(`${baseURL}/production-orders`, {
        params,
        headers,
      });
      
      commit('SET_PURCHASES', response.data);
    } catch (error) {
      console.error('Error fetching production orders:', error);
      throw error;
    }
  },

  /**
   * Creates series, and optionally laser/labels, then refreshes the list
   */
  async createSeries({ dispatch }, { selectedData, options, currentFin, currentCheck, currentSearch }) {
    try {
      const { baseURL, headers } = getApiConfig();
      const body = {
        action: 'create_series',
        selectedData: selectedData,
        options: options
      };
      
      const response = await axios.post(`${baseURL}/production-orders`, body, { headers });

      // After creating, refresh the data list with the *current* filters/search
      await dispatch('fetchPurchases', {
        fin: currentFin,
        check: currentCheck,
        search: currentSearch
      });

      return response.data; // Return response (which may include laser/label data)
    } catch (error) {
      console.error('Error creating series:', error);
      throw error;
    }
  },

  /**
   * Fetches data required for printing labels
   */
  async printLabels({ commit }, { selectedData }) {
    try {
      const { baseURL, headers } = getApiConfig();
      const body = {
        action: 'print_labels',
        selectedData: selectedData
      };
      
      const response = await axios.post(`${baseURL}/production-orders`, body, { headers });
      return response.data; // Returns { labelData: [...] }
    } catch (error) {
      console.error('Error fetching label data:', error);
      throw error;
    }
  },

  /**
   * Triggers the server to create a laser file
   */
  async createLaserFile({ commit }, { selectedData }) {
    try {
      const { baseURL, headers } = getApiConfig();
      const body = {
        action: 'create_laser',
        selectedData: selectedData
      };
      
      const response = await axios.post(`${baseURL}/production-orders`, body, { headers });
      return response.data; // Returns { laserFile: { success: true, ... } }
    } catch (error) {
      console.error('Error creating laser file:', error);
      throw error;
    }
  },

  // This action can be built out later when you have a details page
  async fetchOrderById({ commit }, orderId) {
    // const { baseURL, headers } = getApiConfig();
    // try {
    //   const response = await axios.get(`${baseURL}/production-orders/${orderId}`, {
    //     headers,
    //   });
    //   commit('SET_SELECTED_ORDER', response.data);
    // } catch (error) {
    //   console.error('Error fetching order:', error);
    //   throw error;
    // }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

